var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3703 26C4.60825 25.6179 2.43672 23.4465 2.05469 20.6844L14.0268 8.71223L17.2383 8.69012L19.3646 10.8164L19.3424 14.0278L7.3703 26Z",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2402 8.69037L23.5794 2.35096L25.7056 4.47717L19.3665 10.8166L17.2402 8.69037Z",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.302 9.75348L14.0271 14.0279",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75871 9.51742C7.83458 9.51742 9.51742 7.83458 9.51742 5.75871C9.51742 3.68283 7.83458 2 5.75871 2C3.68283 2 2 3.68283 2 5.75871C2 7.83458 3.68283 9.51742 5.75871 9.51742Z",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48828 7.61279C5.05217 5.11481 6.46474 6.40259 9.02863 3.9046M21.5059 8.67646L19.3795 6.55003",
    stroke: "#3936EF",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/Sports.43622589ebb9595e993e114be177b3fe.svg";
export { ForwardRef as ReactComponent };